import { BaseResponse } from '../../../../../../types/api/api.types';
import { CreateProspectRequestData } from '../../../../../../types/api/endpoints/prospect/create.types';
import { PROSPECT_ENDPOINTS } from '../../../../../../utils/api/endpoints/prospectEndpoints';

const PREFIX = '[createProspectQuery]';

export const CREATE_PROSPECT_QUERY_KEY = 'CREATE_PROSPECT';

export const createProspectQuery = async (data: CreateProspectRequestData) => {
  console.log(PREFIX, `Requesting prospect account creation...`);
  const response = await PROSPECT_ENDPOINTS.create(data);

  const { ok, data: json } = response;

  if (!ok) {
    const error = response.data;
    console.log(PREFIX, 'An error occurred.', error);
    throw error;
  }

  console.log(PREFIX, `Received prospect account creation.`);
  return json as BaseResponse;
};
